import React from "react";
import PropTypes from "prop-types";

const LightStickIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8 8.66699V9.33366"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 1.33301C11.7013 1.33301 12 1.63173 12 1.99967V4.66634C12 5.09908 11.8596 5.52015 11.6 5.86634L11.2 6.39967C10.8538 6.86126 10.6667 7.42269 10.6667 7.99967V13.333C10.6667 14.0689 10.0692 14.6663 9.33333 14.6663H6.66667C5.93078 14.6663 5.33333 14.0689 5.33333 13.333V7.99967C5.33333 7.42269 5.14619 6.86126 4.8 6.39967L4.4 5.86634C4.14036 5.52015 4 5.09908 4 4.66634V1.99967C4 1.63173 4.29872 1.33301 4.66667 1.33301H11.3333"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4H12"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

LightStickIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

LightStickIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default LightStickIcon;
